import React from 'react'
import Structure from './Components/Structure'

const StructurePage = () => {
  return (
    <div>
      <Structure />
    </div>
  )
}

export default StructurePage